export class AddViewEvent {
  private _siteType: string;
  private _urlid: string;
  private _id: string | string[];
  private _editEnabled: boolean = false;

  constructor(
    siteType: string,
    urlid: string,
    id?: string | string[],
    editEnabled: boolean = false,
  ) {
    this._siteType = siteType;
    this._urlid = urlid;
    this._id = id;
    this._editEnabled = editEnabled;
  }

  get siteType(): string {
    return this._siteType;
  }

  get urlid(): string {
    return this._urlid;
  }

  get id(): string | string[] {
    return this._id;
  }

  get editEnabled(): boolean {
    return this._editEnabled;
  }
}
